var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"pb-1",staticStyle:{"color":"#435156"}},[_vm._v("New Business: "+_vm._s(_vm.clientName))]),_c('CaseDetail')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }